import { createContext } from "react";
import { AuthContextInterface } from "./typinds";

const AuthContext = createContext<AuthContextInterface>({
    user: {
        user: { firstName: "", username: "", lastName: "", phone: "", email: "" },
        roles: [{ id: 0, name: "" }]
    },
    signIn: (function (user: any, expireDate: string) { }),
    signOut: (function () { }),
});
export default AuthContext;